/* convenience is the text describing the hotel's location, used in group 2 photos.  */
export const convenienceText = 
	{
		text: 'Our hotels are just over 500 meters from Hakuba Goryu Snow Resort, with rental shops and many restaurants and bars all within walking distance. Free shuttle buses to and from the resort are also available. ',
		textJ: '当ホテルは白馬五竜スノーリゾートからわずか500メートル強の距離にあり、レンタルショップや多くのレストラン、バーが徒歩圏内にあります。リゾートとの間には、無料のシャトルバスも運行しています。',
		textCh1: '我们的酒店距离白马五龙滑雪场仅500多米，租赁店和许多餐厅、酒吧都在步行范围内。我们还提供往返滑雪场的免费班车服务。',
		textCh2: '我們的酒店距離白馬五龍滑雪場僅500多米，租賃店和許多餐廳、酒吧都在步行範圍內。我們還提供往返滑雪場的免費班車服務。'
	}